import * as React from "react";
//import * as cls from "./Sample.module.scss";
export { Sample };
/**
 * Компонент.
 * @param {Object} props - Атрибуты элемента.
 * @param {string} [props.attributeName=defaultValue] - Описание атрибута.
 * @param {JSX.Element} props.children - Содержимое.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Sample({ children }) {
  return <div>{children}</div>
}
